function submitPurchasePayment() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()

    let errorString = [];

    const dateOfPayment = $('#add-purchase-payment-form input[name="purchase_payment[created_at]"]').val()

    if (isEmpty(dateOfPayment)) {
      errorString.push('Purchase date cannot be blank');
    }

    const paymentOptions = getPaymentOptionsStorage()

    if (paymentOptions === null ||
      paymentOptions === undefined ||
      (Array.isArray(paymentOptions) && paymentOptions.length === 0)) {
      errorString.push('Payment option amount not set')
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      // $('#add-purchase-payment-form').submit();
      const postUrl = $('#add-purchase-payment-form').attr('action')
      const redirectUrl = '/purchase_payments'
      const description = $('#add-purchase-payment-form textarea[name="purchase_payment[description]"]').val()
      const purchaseAccountId = $('select[name="purchase_payment[purchase_account_id]"] option:selected').val()

      let action = "post"

      if ($('#add-purchase-payment-form input[name="purchase_payment[purchase_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          payment_options: paymentOptions,
          purchase_payment: {
            created_at: dateOfPayment,
            description: description,
            purchase_account_id: purchaseAccountId,
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          window.location.replace(redirectUrl)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }


  });
}

function getPurchasePaymentData(purchasePaymentId){
  $.ajax({
    type: "post",
    url: `/purchase_payment_details/${purchasePaymentId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      console.log(data)
      setPaymentPurchaseRows(data)
    },
    error: function (data) {
      console.log('An error occurred.');
      console.log(data);
    },
  });
}

function setPaymentPurchaseRows(purchasePaymentData) {
  console.log(purchasePaymentData)

  if (purchasePaymentData === null || purchasePaymentData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".purchase-payment-data").empty()

  let total = 0

  // set data rows
  $.each(purchasePaymentData, function (key, paymentDetails) {
    if (paymentDetails === null) {
      return
    }
    const accountName = paymentDetails.account_name
    const reference = paymentDetails.details
    const amount = paymentDetails.amount
    const elementId = `${key}${paymentDetails.account_id}`

    total += parseFloat(amount)


    $(".purchase-payment-data").append(
      `<tr id='${elementId}'>
        <td class="account-name" >${accountName}</td>
        <td class="reference">${reference}</td>
        <td class="total-amount text-right">${numberWithCommas(amount)}</td>
      </tr>`
    )
  })

  // const totalAmount = calculateTotalAmount()

  // set total row
  $(".purchase-payment-data").append(
    `<tr id='payment-purchase-total'>
      <td><strong>TOTAL</strong></td>
      <td></td>
      <td class='total-payment text-right'>
        <strong>${numberWithCommas(total)}</strong>
      </td>
    </tr>`)

}

$(document).ready(function () {
  if ($('#add-purchase-payment-form').length > 0) {
    clearFailedSubmit('#add-purchase-payment-form')

    submitPurchasePayment()
  }

  $('.view-purchase-payment-details').click(function () {
    const purchasePaymentId = $(this).data('purchase-payment-id')
    getPurchasePaymentData(purchasePaymentId)
  })
});
